<template>
<b-form @submit="onSubmit" class="contact-form circled bg-white pt-4 pb-2 px-5 h-100">
  <b-form-group class="font-weight-bold" id="input-group-nombre" label="Nombre:" label-for="input-nombre">
    <b-form-input
      class="form-control-sm"
      id="nombre"
      v-model="form.nombre"
      required
    ></b-form-input>
  </b-form-group>
  <b-form-group class="font-weight-bold" id="input-group-correo" label="Correo:" label-for="input-correo">
    <b-form-input
      class="form-control-sm"
      id="correo"
      required
      v-model="form.correo"
    ></b-form-input>
  </b-form-group>
  <b-form-group class="font-weight-bold" id="input-group-tel" label="Teléfono:" label-for="input-tel">
    <b-form-input
      class="form-control-sm"
      id="telefono"
      required
      v-model="form.telefono"
    ></b-form-input>
  </b-form-group>
  <b-form-group class="font-weight-bold" id="input-group-asunto" label="Asunto:" label-for="input-asunto">
    <b-form-input
      class="form-control-sm"
      id="asunto"
      required
      v-model="form.asunto"
    ></b-form-input>
  </b-form-group>
  <b-form-group class="font-weight-bold" id="input-group-mensaje" label="Mensaje:" label-for="input-mensaje">
    <b-form-textarea
      class="form-control-sm"
      id="input-mensaje"
      required
      v-model="form.mensaje"
      rows="8"
    ></b-form-textarea>
  </b-form-group>
  <b-form-group>
    <b-button style="float:right;" @click="onSubmit" class="px-5" type="submit" variant="primary">Enviar</b-button>
  </b-form-group>
</b-form>
</template>

<script>
const querystring = require("querystring");
export default {
  name: 'Form',
  data () {
    return {
      form: {
        nombre: '',
        correo: '',
        telefono: '',
        asunto: '',
        mensaje: ''
      }
    }
  },
  methods: {
    onSubmit (e) {
      e.preventDefault()
      console.log(this.form)
      this.$http
        .post("https://transportesttc.com.mx/test/contact.php",
        querystring.stringify(this.form))
      .then(res => {
        console.log(res)
      })
      alert('¡Mensaje enviado!')
    }
  }
}
</script>

<style scoped>
.circled {
  border-radius: 5px;
}
</style>
